import { render } from "./TemplateReport.vue?vue&type=template&id=70f75322"
import script from "./TemplateReport.vue?vue&type=script&lang=js"
export * from "./TemplateReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__